<template>
  <div class="container">
    <div class="title">
      <div class="name">{{mainRuleInfo.ruleTitle}}</div>
      <div class="score">总分{{mainRuleInfo.ruleScore}}分</div>
    </div>
    <div class="content" v-for="(item,index) in ruleList" :key="index">
      <h1>{{item.ruleTitle}}</h1>
      <p v-html="item.ruleDesc"></p>
    </div>
  </div>
</template>
<script>
    import api from '../../service/modules/appraise';
    export default {
        components: {
        },

        data () {
            return {
                mainRuleInfo: {
                    ruleTitle: '',
                    ruleScore: ''
                },
                ruleList: []
            }
        },

        computed: {},

        watch: {},

        methods: {
            getRuleList () {
                api.getAssessRule({
                    upRuleCode: this.asscessType
                }).then(res => {
                    if (res.ret === 0) {
                        this.mainRuleInfo = res.data.mainRuleInfo
                        this.ruleList = res.data.ruleList
                    }
                });
            }

        },

        mounted () {
        },

        created () {
            this.asscessType = this.$route.query.asscessType
            this.getRuleList()
        }

    }
</script>
<style scoped lang="less">
  .container {
    height: 100vh;
    background: #fff;
    .title{
      padding: 24px 12px;
      border-bottom: solid 1px #EEEEEE;
      .name{
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
      .score{
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:16px;
        margin-top: 16px;
      }
    }
    .content{
      padding: 24px 12px 0 24px;
      h1{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:16px;
      }
      p{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:22px;
        margin-top: 16px;
      }
    }
  }
</style>
